import React from "react";

const PageBanner = ({ eyebrow, title, subtitle, image, height = "min(60vh, 520px)" }) => (
  <section
    className="relative isolate overflow-hidden"
    style={{ minHeight: height }}
    data-testid="page-banner"
  >
    <div className="absolute inset-0 -z-10">
      <img
        src={image}
        alt=""
        aria-hidden="true"
        className="h-full w-full object-cover"
        style={{ objectPosition: "center 45%" }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(26,12,6,0.65) 0%, rgba(26,12,6,0.5) 45%, rgba(26,12,6,0.85) 100%)",
        }}
      />
    </div>
    <div
      className="relative max-w-5xl mx-auto px-6 lg:px-8 flex flex-col items-center justify-center text-center"
      style={{ minHeight: height, paddingTop: 80, paddingBottom: 80 }}
    >
      {eyebrow && (
        <span
          className="font-serif-display uppercase tracking-[0.35em] text-xs sm:text-sm mb-4"
          style={{ color: "#ecdcbd" }}
        >
          {eyebrow}
        </span>
      )}
      <h1
        className="font-serif-display text-white font-bold leading-[1.08]"
        style={{ fontSize: "clamp(2rem, 4.5vw, 3.8rem)", textShadow: "0 4px 24px rgba(0,0,0,0.55)" }}
      >
        {title}
      </h1>
      {subtitle && (
        <>
          <div className="mt-5 flex items-center gap-3">
            <span className="h-px w-10" style={{ background: "#c5371f" }} />
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: "#c5371f" }} />
            <span className="h-px w-10" style={{ background: "#c5371f" }} />
          </div>
          <p
            className="mt-5 max-w-2xl text-base sm:text-lg"
            style={{ color: "#fbf5e9", opacity: 0.92 }}
          >
            {subtitle}
          </p>
        </>
      )}
    </div>
  </section>
);

export default PageBanner;
